
import Component from "vue-class-component";
import Vue from "vue";
import {
    AddInlandVesselPracticeRequest,
    PracticesClient,
    InlandVesselPracticeActions,
    InlandVesselPracticeDetailsModel,
    IAddInlandVesselPracticeRequest,
    factory
} from "@/api-client";
import InlandVesselPracticeUpsertForm from "@/features/documents/practices/components/InlandVesselPracticeUpsertForm.vue";
import FormLayout from "@/features/personProfile/components/FormLayout.vue";
import {Prop} from "vue-property-decorator";
import {NavigationGuardNext} from "vue-router/types/router";
import {Location} from "vue-router";

interface Props {
    seafarerId: string;
    actions: InlandVesselPracticeActions;
    existingPractice: InlandVesselPracticeDetailsModel;
}

@Component({
    components: {
        FormLayout,
        InlandVesselPracticeUpsertForm
    },
    beforeRouteEnter(to, from, next: NavigationGuardNext<EditInlandVesselPractice>) {
        const props = to.meta!.props as Props;
        props.seafarerId = to.params.seafarerId;
        const practiceId = to.params.id;
        Promise.all([
            new PracticesClient().availableInlandVesselActions(),
            new PracticesClient().getInlandVesselPractice(practiceId),
        ]).then(values => {
            props.actions = values[0];
            props.existingPractice = values[1];
            next();
        }).catch(e => next(e))
    }
})
export default class EditInlandVesselPractice extends Vue implements Props {
    @Prop({required: true})
    seafarerId!: string;

    @Prop({required: true})
    actions!: InlandVesselPracticeActions;

    @Prop({required: true})
    existingPractice!: InlandVesselPracticeDetailsModel;

    @Prop({default: null})
    returnRoute!: Location | null;

    model: AddInlandVesselPracticeRequest = factory.create(AddInlandVesselPracticeRequest);
    isCreated = false;

    created() {
        // Create model similar to how SeafaringPractice does it
        this.model = new AddInlandVesselPracticeRequest({
            ...this.existingPractice,
            existingFiles: this.existingPractice.files || [],
            addedFiles: [],
            removedFiles: []
        } as IAddInlandVesselPracticeRequest);

        this.isCreated = true;

        // Then set the date after the form is created
        if (this.existingPractice.issuedOn) {
            this.$nextTick(() => {
                // Create a fresh Date object from the timestamp
                const dateObj = new Date(this.existingPractice.issuedOn);
                const freshDate = new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate());
                this.model.issuedOn = freshDate;
            });
        }
    }

    async submit(model: AddInlandVesselPracticeRequest): Promise<void> {
        await new PracticesClient().edit(model, this.seafarerId, this.existingPractice.id);

        // Navigate back to the context where the edit was initiated
        const route = (this.returnRoute ? this.returnRoute : { name: "seafarer-practices" }) as Location;
        route.params = { seafarerId: this.seafarerId};
        this.$router.replace(route);
    }
}
